/**
 * Created by A on 2/22/2017.
 */
BookingApp.controller('HotelController',function($scope,HotelServices,$route){
    //console.log($scope.$resolve);
    $scope.HotelInfo = $scope.$resolve.data.hotelInfo;
    $scope.HotelRoom = $scope.$resolve.data.hotelRooms.HotelRoomsDetails;


    $scope.sliderOptions = {
        $AutoPlay: true,
        $SlideshowOptions: {
            $Class: $JssorSlideshowRunner$,
            $Transitions: [],
            $TransitionsOrder: 1
        },
        $ArrowNavigatorOptions: {
            $Class: $JssorArrowNavigator$
        },
        $ThumbnailNavigatorOptions: {
            $Class: $JssorThumbnailNavigator$,
            $Cols: 10,
            $SpacingX: 8,
            $SpacingY: 8,
            $Align: 360
        }
    }
});